import App from 'app/App'
import { fetchCardData } from 'entities/Card'
import { fetchCollectionData } from 'entities/Collection/services/fetchCollectionData'
import { getStatus, getUid } from 'features/anonymousAuth'
import { getMode } from 'features/modeLogic'
import { modeActions } from 'features/modeLogic/model/slice/modeLogicSlice'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'
import { MinecardsLoader } from 'shared/ui/MinecardsLoader'
import { isStandalonePwa } from 'shared/lib/isStandalonePwa/isStandalonePwa'
import React from 'react'

export const LoadDataProvider = () => {
    const uid = useSelector(getUid)
    const dispatch = useDispatch()
    const location = useLocation()
    const isSpecialRoute = location.pathname === '/special'
    const statusCards = useSelector(getStatus)
    const statusCollection = useSelector((state) => state.collection.status)

    const mode = useSelector(getMode)

    const [installPrompt, setInstallPrompt] = useState() // установка приложения

    useEffect(() => {
        // Каталог публичный: ждём только завершения проверки локальной сессии.
        if (uid === undefined) {
            return
        }
        if (!isSpecialRoute) {
            dispatch(fetchCollectionData())
            dispatch(fetchCardData('cards'))
        } else {
            dispatch(modeActions.setMode('special'))
            dispatch(fetchCardData('special'))
        }
    }, [dispatch, isSpecialRoute, uid])

    useEffect(() => {
        //запуск установки
        if (isStandalonePwa()) {
            return undefined
        }

        const ua = navigator.userAgent
        if (/android/i.test(ua)) {
            dispatch(modeActions.setAgent('android'))
        } else if (
            /iPad|iPhone|iPod/.test(ua) ||
            (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
        ) {
            dispatch(modeActions.setAgent('ios'))
        } else {
            dispatch(modeActions.setAgent('browser'))
        }

        const handleInstallPrompt = (event) => {
            event.preventDefault()
            dispatch(modeActions.setInstallPossibility(true))
            setInstallPrompt(event)
        }
        const handleInstalled = () => {
            setInstallPrompt('installed')
            dispatch(modeActions.setMode('installed'))
        }

        window.addEventListener('beforeinstallprompt', handleInstallPrompt)
        window.addEventListener('appinstalled', handleInstalled)

        return () => {
            window.removeEventListener(
                'beforeinstallprompt',
                handleInstallPrompt
            )
            window.removeEventListener('appinstalled', handleInstalled)
        }
    }, [dispatch])

    useEffect(() => {
        // проверка возможности установки пушей (не срабатывает при уже установленном + ios)
        if ('Notification' in window) {
            if (Notification.permission === 'default') {
                dispatch(modeActions.setPushPossibility(true))
            } else {
                dispatch(modeActions.setPushPossibility(false))
            }
        } else {
            dispatch(modeActions.setPushPossibility(false))
        }
    }, [dispatch])

    if (mode === 'special') {
        return (
            <>
                {statusCards === 'resolved' ? (
                    <App
                        installPrompt={installPrompt}
                        onInstallPromptHandled={() =>
                            setInstallPrompt(undefined)
                        }
                    />
                ) : (
                    <MinecardsLoader />
                )}
            </>
        )
    } else {
        return (
            <>
                {statusCards === 'resolved' &&
                statusCollection === 'resolved' ? (
                    <App
                        installPrompt={installPrompt}
                        onInstallPromptHandled={() =>
                            setInstallPrompt(undefined)
                        }
                    />
                ) : (
                    <MinecardsLoader />
                )}
            </>
        )
    }
}
